import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const useProfileClaimed = (dancerName) => {
  const [isProfileClaimed, setIsProfileClaimed] = useState(false);
  const [claimedBy, setClaimedBy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkProfileClaimed = async () => {
      if (!dancerName) {
        setLoading(false);
        return;
      }

      try {
        // Check both dancers collection and dancerProfiles collection
        const dancerRef = doc(db, 'dancers', dancerName);
        const dancerSnap = await getDoc(dancerRef);
        
        if (dancerSnap.exists()) {
          const data = dancerSnap.data();
          if (data.claimedBy) {
            setIsProfileClaimed(true);
            setClaimedBy(data.claimedBy);
            setLoading(false);
            return;
          }
        }

        // Also check dancerProfiles collection
        const profileRef = doc(db, 'dancerProfiles', dancerName);
        const profileSnap = await getDoc(profileRef);
        
        if (profileSnap.exists()) {
          const profileData = profileSnap.data();
          if (profileData.claimedBy && profileData.profileClaimed) {
            setIsProfileClaimed(true);
            setClaimedBy(profileData.claimedBy);
          } else {
            setIsProfileClaimed(false);
            setClaimedBy(null);
          }
        } else {
          setIsProfileClaimed(false);
          setClaimedBy(null);
        }
      } catch (error) {
        console.error('Error checking profile claimed status:', error);
        setIsProfileClaimed(false);
        setClaimedBy(null);
      } finally {
        setLoading(false);
      }
    };

    checkProfileClaimed();
  }, [dancerName]);

  return { isProfileClaimed, claimedBy, loading };
};
